@if (currentUser()) {
  <div class="user-and-org-dropdown" [class.user-and-org-dropdown--collapsed]="collapsed">
    <a class="user-and-org-dropdown__user" [routerLink]="['/', appPaths.NotFound]">
      <div class="user-and-org-dropdown__user-avatar">
        <ftr-user-avatar [user]="currentUser()" size="Small" />
      </div>
      @if (!collapsed) {
        <div class="user-and-org-dropdown__name">{{ currentUser()!.givenName }} {{ currentUser()!.familyName }}</div>
      }
    </a>

    @if (displayMode === 'OVERLAY') {
      <ftr-icon-legacy
        icon="ChevronRight"
        size="Small"
        align="Middle"
        tabindex="0"
        class="user-and-org-dropdown__opener"
        (click)="dropdownOpened.emit()"
      />
    } @else {
      <ftr-dropdown-menu-legacy
        ariaLabel="User menu"
        [openerTemplate]="openerTemplate"
        [menuItems]="menuItems"
        [isLeftPositioned]="collapsed"
        [invalidTargetNames]="[componentSelector]"
        data-track-group="Public Side Nav User Dropdown"
      />
    }
  </div>
}

<ng-template #openerTemplate>
  <button
    class="user-and-org-dropdown__opener"
    [class.user-and-org-dropdown__opener--collapsed]="collapsed"
    aria-label="Open user menu"
    (click)="toggle()"
    (keydown.enter)="toggle()"
  >
    <ftr-icon-legacy [align]="collapsed ? 'Middle' : 'Sub'" [size]="collapsed ? 'Large' : 'Small'" icon="ChevronDown" />
  </button>
</ng-template>
